export default {
    internal_server_error: 'An error occurred, please try again later.',
    require_username: 'Please enter username',
    require_password: 'Please enter password',
    wrong_username_password: 'Wrong username or password!',
    fail_to_load_clients: 'Fail to load clients!',
    fail_to_load_invoices: 'Fail to load invoices!',
    fail_to_load_client_domains: "Fail to load client's domain",
    fail_to_load_client: 'Fail to load client info',
    fail_to_load_setting: 'Fail to load commission rate',
    fail_to_save_setting: 'Fail to save commission rate',
    save_setting_success: 'Save commission rate success',
    save_invoice_success: 'Save invoice success',
    fail_to_save_invoice: 'Fail to save invoice',
    require_commission: 'Please enter commission',
    integer: 'Please enter an integer',
    rage_0_100: 'Must be greater than 0 and less than 1000',
    require_status: 'Please choose status',
    require_current_password: 'Please enter old password',
    require_new_password: 'Please enter new password',
    require_confirm_password: 'Please enter confirm password',
    confirm_password_not_match: 'Confirm password does not match new password',
    password_rage_length:
        'Password length must be from {min} to {max} characters',
    password_white_space: 'Password does not include spaces',

    save_password_success: 'Update password success',
    wrong_password: 'Wrong password',
    invalid_password:
        'Password must have at least one uppercase letter, one lowercase letter, one number',
    date_from_to: 'The starting date must be less than the ending date',
    amount_from_to: 'The starting amount must be less than the ending amount',
    earned_from_to: 'The starting earned must be less than the ending earned',
    discount_from_to:
        'The starting discount must be equal or less than the ending discount',
    require_date_from: 'The start date is required',
    require_date_to: 'The end date is required',
    update_status_success: 'Update status success',
    required_mail_box: 'Mail box is required',
    max_mail_box: 'Mail box is too long',
    invalid_mail_box: 'Invalid mail box',
    required_forward_to: 'Forward to is required',
    email_forward_to: 'Forward to must be an email',
    max_forward_to: 'Forward to is too long',
    invalid_host_name: 'Invalid Source URL',
    required_host_name: 'Source URL is required',
    max_host_name: 'Source URL is too long',
    invalid_domain: 'Invalid domain',
    invalid_connect_domain:
        "Please input a valid domain. The domain cannot start with 'www.'",
    required_address: 'Destination URL is required',
    max_address: 'Destination URL is too long',
    invalid_address:
        'Invalid URL. Please include a valid protocol. Example: <b>https://example.com</b> or <b>http://example.com</b>',
    power_action_error: 'Failed to {value}. Please try again later',
    power_state_error: 'Failed to get server power state',
    power_restart_success: 'Restart server successfully',
    country_not_available:
        'This country is not available with <b>{tld}</b>. Please choose a different country',
    required_first_name: 'Please enter first name',
    required_last_name: 'Please enter last name',
    required_address_profile: 'Please enter address',
    required_postal_code: 'Please enter postal code',
    required_country: 'Please choose country',
    required_city: 'Please enter city',
    required_state_province: 'Please enter state/province',
    required_phone: 'Please enter phone number',
    required_email: 'Please enter email address',
    invalid_email: 'Email is invalid',
    invalid_postal_code: 'Postal code is wrong format for selected country',
    failed_to_load_wallet_history: 'Failed to load wallet history.',
    bank_name_required: 'Bank name is required',
    bank_name_max: "Bank name isn't allowed to be greater than 255 characters",
    account_number_required: 'Account number is required',
    account_number_max:
        "Account number isn't allowed to be greater than 34 characters",
    account_name_required: 'Account name is required',
    account_name_max:
        "Account name isn't allowed to be greater than 255 characters",
    amount_required: 'Amount is required',
    amount_min: 'Minimum amount is $10',
    amount_less_than: 'Amount must be less than {max}',
    amount_withdraw_greater_than_balance:
        'Balance is insufficient for a withdrawal',
    update_successful: 'Update Successful',
    fail_to_load_data: 'Fail to load data',
    invalid_file: 'The file is not in the correct format',
    max_file_size: 'The maximum file size is {size}',
    invalid_brand_name: 'Brandname is invalid',
    required_brand_name: 'Brandname is required',
    file_required: 'File upload is required',
    required_category: 'Category is required',
    required_content: 'Content is required',
    max_content:
        'Maximum number of SMS is {value}. Please update your content.',
    required_subject: 'Subject is required',
    required_sender: 'Brandname is required',
    max_subject: 'Subject is too long',
    max_category: 'Category is too long',
    required_group_name: 'Group name is required',
    required_full_name: 'Fullname is required',
    required_phone_number: 'Phone is required',
    max_full_name: 'Fullname must be less than {max}',
    required_date_of_birth: 'Birthday is required',
    invalid_date: 'Invalid date',
    invalid_phone: 'Invalid phone number',
    send_sms_success: 'Send SMS success',
    content_must_has_character: 'Content must be at least 1 character',
    required_date: 'Date is required',
    duplicate_phone: 'Phone number already exist',
    required_future_date: 'Please enter a future time',
    before_leave_confirm_mgs:
        'Your data will be lost! Are you sure you want to exit?',
    are_you_sure: 'Are you sure?',
    delete_record_confirm_message: 'Are you sure you want to delete record?',
    delete_record: 'Delete Record?',
    please_enter_value: 'Please enter value',
    successful: 'Successful',
    please_add_mx_record: 'Please add MX Record',
    invalid_nameserver: 'Nameserver invalid',
    email_wrong_format: 'Email address is wrong format',
    required_description: 'Description is required',
    phone_wrong_format: 'Phone is wrong format',
    required_domain: 'Please enter domain',
    update_main_domain_success: 'Your main domain has been updated',
    copied_to_clipboard: 'Copied to clipboard',
    email_verified: 'Your email address has been verified',
    send_otp_success: 'OTP code has been sent',
    turn_on_auto_renewal_title: 'Turn On Auto-Renewal',
    turn_off_auto_renewal_title: 'Turn Off Auto-Renewal',
    turn_on_auto_renewal_content: `You're about to turn on auto-renewal for your service.`,
    turn_off_auto_renewal_content: `You're about to turn off auto-renewal for your service.`,
    required_server_name: 'Please enter server name',
    max_server_name:
        'Server name must be shorter than or equal to 40 characters',
    update_server_name_success: 'Update server name success',
    company_name_max_length:
        "Company name isn't allowed to be greater than {max} characters",
    company_address_max_length:
        "Company address isn't allowed to be greater than {max} characters",
    vat_tin_max_length:
        "VAT TIN isn't allowed to be greater than {max} characters",
    company_phone_max_length:
        "Company phone isn't allowed to be greater than {max} characters",
    representative_max_length:
        "Representative name isn't allowed to be greater than {max} characters",
    disable_pop_up_blocker: 'Please disable your pop-up blocker and try again.',
    card_saved_success: 'This card has been saved successfully',
    card_added_success: 'Your new card has been added',
    payment_method_saved_success: 'Payment method has been saved successfully',
    payment_deleted_card_success: 'This card has been deleted successfully',
    payment_user_info_missing:
        'Some personal information is missing. Please update your information before adding a card.',
    invalid_name:
        'Invalid name. It must not contain numbers or special characters',
    invalid_billing_address:
        'Invalid address. It must not contain special characters such as: | \\ {} [] <>',
    invalid_city:
        'Invalid city. It must not contain special characters such as: | \\ {} [] <>',
    invalid_state_province:
        'Invalid state province. It must not contain special characters such as: | \\ {} [] <>',
    cancel_sms_transaction_success:
        'This transaction has been canceled successfully',
    authentication_code_required: 'Please enter authentication code',
    min_authentication_code:
        'Authentication code must be at least {min} numbers',
    max_authentication_code:
        'Authentication code must be shorter than or equal to {max} numbers',
    two_fa_enabled: 'Two-factor authentication is enabled',
    two_fa_disabled: 'Two-factor authentication is disabled',
    invalid_2fa_code: 'Incorrect verification code',
    required_website_name: 'Please enter website name',
    max_website_name:
        'Website name must be shorter than or equal to {max} characters',
    website_name_saved_success: 'Website name has been saved successfully',
    delete_backup_confirm:
        'Are you sure you want to delete the backup with file name is {fileName}?',
    delete_backup_success: 'This backup has been deleted successfully',
    upgrade_wp_plugin_confirm:
        'Are you sure you want to upgrade the {pluginName} plugin?',
    activate_plugin_success:
        'The {pluginName} plugin has been activated successfully',
    deactivate_plugin_success:
        'The {pluginName} plugin has been deactivated successfully',
    delete_wp_plugin_confirm:
        'Are you sure you want to delete the {pluginName} plugin?',
    delete_wp_plugin_success:
        '{pluginName} plugin has been deleted successfully',
    upgrade_wp_plugin_success:
        'The {pluginName} plugin has been upgraded successfully',
    generate_ftp_account_success: 'FTP account has been generated successfully',
    regenerate_ftp_db_url_success:
        'FTP and phpMyAdmin URL has been updated successfully',
    revoke_ftp_account_success: 'FTP account has been revoked successfully',
    generate_db_account_success:
        'Database account has been generated successfully',
    revoke_db_account_success: 'Database account has been revoked successfully',
    upgrade_wp_confirm: 'Are you sure you want to upgrade WordPress?',
    upgrade_theme_success:
        'The {themeName} theme has been upgraded successfully',
    delete_theme_success: 'The {themeName} theme has been deleted successfully',
    activate_theme_success:
        'The {themeName} theme has been activated successfully',
    waiting_for_processing: 'Waiting for processing',
    wait_download_done:
        'You currently have an ongoing process. Please wait for completion before continuing.',
    max_backup_note:
        'Backup note must be shorter than or equal to {max} characters',
    csr_required: 'CSR is required',
    csr_invalid: 'CSR is invalid',
    domain_invalid: 'Domain is invalid',
    required_company_name: 'Company name is required',
    email_has_been_resent: 'Validation email has been resent',
    duplicated_domain: "You've already entered this domain",
    max_company_business_name:
        "Company business name isn't allowed to be greater than {max} characters",
    max_company_registration_number:
        "Registration number isn't allowed to be greater than {max} characters",
    max_state_province:
        "State isn't allowed to be greater than {max} characters",
    max_city: "City isn't allowed to be greater than {max} characters",
    max_postal_code:
        "Zip/postal isn't allowed to be greater than {max} characters",
    max_legal_address:
        "Address isn't allowed to be greater than {max} characters",
    max_country: "Country isn't allowed to be greater than {max} characters",
    organization_first_name:
        "First name isn't allowed to be greater than {max} characters",
    organization_last_name:
        "Last name isn't allowed to be greater than {max} characters",
    job_title: "Job title isn't allowed to be greater than {max} characters",
    organization_email:
        "Organization email isn't allowed to be greater than {max} characters",
    invalid_registration_number: 'Registration number is invalid',
    edit_dcv_method_success: 'Change DCV Method for {domains} successfully!',
    change_email_success: 'Your email has been changed',
    retrieve_activity_logs_error:
        'Unable to retrieve the list of activity logs',
    cannot_reactivate_domain: 'Domain is not supported for reactivation',
    required_backup_name: 'Please enter backup name',
    max_backup_name:
        "Backup name isn't allowed to be greater than {max} characters",
    cron_hourly: 'Each job must be at least 1 hour apart',
    invalid_cron_expression: 'Invalid cron expression',
    cloud_server_backup_enabled: 'Your cloud server backup is enabled',
    cloud_server_backup_disabled: 'Your cloud server backup is disabled',
    cloud_server_backup_restored: 'Your cloud server backup is restored',
    cloud_server_backup_rename_success:
        'Your cloud server backup name is updated',
    send_try_demo_sms_success: 'SMS has been sent',
    required_authorization_code: 'Please enter authorization code',
    max_authorization_code:
        "Authorization code isn't allowed to be greater than {max} characters",
    change_password_success:
        'Your request being processing. New password will be send to your email shortly.',
    required: 'This field is required',
    invalid_format: 'This field is invalid format',
    service_still_expired:
        'The new expiration date is {newExpiration}, so your service is still expired.',
    require_otp: 'Please enter OTP',
    continue_link_account:
        'Password and OTP are valid. Please click the button below to continue linking your Google account.',
    contract_confirmed: 'Contract is confirmed',
};
